import { elements } from '../periodicElements';
import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { handleElementClick, renderElementVideo, renderColumn } from '../FunctionsElements';
import { useTranslation } from 'react-i18next';

export default function Renewable() {
  const [selectedElement, setSelectedElement] = useState(null);
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section>
      {selectedElement ? (
        /* Visualização do Elemento Selecionado */
        <section className="bg-background-secondary min-h-screen flex items-center justify-center p-4 transition-colors duration-300">
          <div className="w-full max-w-4xl">
            {renderElementVideo(selectedElement, setSelectedElement, t, navigate)}
          </div>
        </section>
      ) : (
        /* Visualização Principal da Categoria */
        <section className="mx-auto min-h-screen pt-28 pb-12 bg-background-secondary px-4 transition-colors duration-300">
          <div className="max-w-7xl mx-auto flex flex-col">
            
            {/* Bloco do Botão: Isolado no topo e alinhado à esquerda */}
            <div className="w-full mb-8 flex justify-start lg:ml-8">
              <Link to="/TPQVS"> 
                <button 
                  className="bg-primary text-white font-bold py-2 px-6 rounded-md shadow-lg transition-transform transform hover:scale-105 hover:bg-opacity-90">
                  {t("elements.back")}
                </button>
              </Link>
            </div>

            <div className="flex flex-col lg:flex-row justify-center items-center lg:items-start gap-10 w-full">
              
              {/* CONTAINER DA TABELA*/}
              <div className="grid grid-cols-1 gap-0 text-center w-fit shadow-2xl border-collapse">
                {renderColumn(elements, 37, 41, false, 0, handleElementClick, setSelectedElement, true)} 
              </div>

              {/* Card de Texto Informativo */}
              <div className="w-full p-6 lg:w-2/4 bg-surface border border-border-light rounded-lg shadow-lg text-text-primary mt-6 lg:mt-0 lg:ml-4 transition-colors duration-300">
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-center mb-4 border-b-2 border-primary text-text-primary pb-2">
                  {t("RenewableFeedstocks.title")} 
                </h2>
                <p className="text-xs sm:text-sm md:text-base leading-relaxed text-justify text-text-secondary">
                  {t("RenewableFeedstocks.discretion")} 
                </p>
              </div>

            </div>
          </div>
        </section>
      )}
    </section>
  );
}